export default __webpack_public_path__ + "static/media/bellagioKlein.578d3f57.jpg";